import * as React from "preact";
import { render } from "preact";

import App from "./App"; // eslint-disable-line @typescript-eslint/no-unused-vars

function init() {
  const el = document.getElementById("cashhub-app");
  if (el) {
    const {
      apiUrl,
      easyAccessLabel,
      fixedRateBondLabel,
      noticeAccountLabel,
      errorTitleLabel,
      errorMessageLabel,
      cashhubClientType,
    } = el.dataset;
    if (apiUrl) {
      render(
        <App
          apiUrl={apiUrl}
          easyAccessLabel={easyAccessLabel || "Easy access"}
          fixedRateBondLabel={fixedRateBondLabel || "Fixed rate bond"}
          noticeAccountLabel={noticeAccountLabel || "Notice account"}
          errorTitleLabel={errorTitleLabel || "Error"}
          errorMessageLabel={errorMessageLabel || "There was an unexpected error"}
          cashhubClientType={cashhubClientType || ""}
        />,
        el
      );
    }
  }
}

export default { init };
